import React from 'react';
import styled from 'styled-components/macro';
import logo from './GMV_RGBred.svg';

const HeaderContainer = styled.header`
  margin: 45px;
  align-self: flex-start;
  display: flex;
  align-items: top;
`;

const Header = () => (
  <HeaderContainer>
    <a
      href="http://www.gmvsync.com"
      title="GVM Sync"
      target="_blank"
      rel="noreferrer noopener"
    >
      <img src={logo} alt="GMV logo" />
    </a>
  </HeaderContainer>
);

export default Header;
